import React from 'react';
import { Modal, Button } from 'antd';
import styled from 'styled-components';
import warningIcon from '../../assets/icons/ic-warning.svg';

interface IdleTimeoutModalProps {
  open: boolean;
  remainingTime: number;
  onStayLoggedIn: () => void;
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 24px;
  }

  .ant-modal-body {
    text-align: center;
    padding: 24px 24px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;

  img {
    width: 62px;
    height: 62px;
  }
`;

const Title = styled.h3`
  font-family: Inter;
  font-weight: 700;
  font-size: 20px;
  color: #1F2937;
  margin: 0 0 16px 0;
`;

const Description = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 8px 0;
`;

const Countdown = styled.div`
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  color: #DC2626;
  margin: 0 0 32px 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`;

const StayButton = styled(Button)`
  min-width: 155px;
  height: 46px;
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px;
  background: #2563EB;
  border-color: #2563EB;
  color: #FFFFFF;
  
  &:hover {
    background: #1D4ED8 !important;
    border-color: #1D4ED8 !important;
    color: #FFFFFF !important;
  }
`;

function formatTime(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

const IdleTimeoutModal: React.FC<IdleTimeoutModalProps> = ({
  open,
  remainingTime,
  onStayLoggedIn,
}) => {
  return (
    <StyledModal
      open={open}
      footer={null}
      centered
      closable={false}
      maskClosable={false}
      width={450}
      zIndex={2000}
    >
      <IconWrapper>
        <img src={warningIcon} alt="Session expiring" />
      </IconWrapper>
      <Title>Session About to Expire</Title>
      <Description>
        Your session is about to expire due to inactivity. Click below to stay logged in.
      </Description>
      <Countdown>{formatTime(remainingTime)}</Countdown>
      <ButtonGroup>
        <StayButton type="primary" onClick={onStayLoggedIn}>
          Stay Logged In
        </StayButton>
      </ButtonGroup>
    </StyledModal>
  );
};

export default IdleTimeoutModal;
